import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { UsersManagementApiService } from '../../../services/users-management-api.service';
import { ToastNotificationService } from '../../../../../notifications/services/toast-notification.service';
import { ToastNotificationType } from '../../../../../notifications/models/toast-notification-type';
import { VendorStaff } from '../../../models/VendorStaff';
import { TableSkeletonRowComponent } from '../../../../../shared/components/table-skeleton-row/table-skeleton-row.component';
import { AuthService } from '../../../../auth/services/auth.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-user-management-page',
  imports: [CommonModule, RouterLink, TableSkeletonRowComponent, TranslateModule],
  templateUrl: './user-management-page.component.html',
  styleUrl: './user-management-page.component.css'
})
export class UserManagementPageComponent implements OnInit {

  apiService = inject(UsersManagementApiService);
  authService = inject(AuthService);
  vendorStaff: VendorStaff[] | undefined;
  toastNotificationService = inject(ToastNotificationService);
  translate = inject(TranslateService);
  isOwner = this.authService.isOwner();

  ngOnInit(): void {
    this.apiService.getVendorStaff().subscribe({
      next: (response) => {
        this.vendorStaff = response;
      },
      error: () => {
        this.toastNotificationService.createNotification(
          this.translate.instant('users_management.list.errors.load_failed'),
          ToastNotificationType.ERROR
        );
      }
    });
  }

  onSearchChange(event: any) {
  }
}
